import React, { useEffect, useState } from "react"
import Grid from "@material-ui/core/Grid"
import Layout from "../components/layout"
import PremiumServices from "../components/Sidebar/PremiumServices"
import { Link } from "gatsby"
import Seo from "../components/seo"
import axios from "axios"
import Loading from "./loading"
import Button from "@material-ui/core/Button"
import "../components/pageStyles.scss"

const AboutJerseyMet = () => {
  const [aboutJerseyMetData, setAboutJerseyMetData] = useState([])
  const [servicesProvidedData, setServicesProvidedData] = useState([])
  const [url, setUrl] = useState(process.env.MET_ABOUTJERSEYMET)
  const [loading, setloading] = useState(true)
  const [error, setError] = useState(false)
 
  useEffect(() => {
    const fetchData = async () => {
      setError(false)
      setloading(true)
      try {
        const result = await axios(url)
        setAboutJerseyMetData(result.data.aboutJerseyMet)
        setServicesProvidedData(result.data.serviceProvided)
      } catch (error) {
        setError(true)
        console.log(error)
      }
      setloading(false)
    }
    fetchData()
  }, [url])

  return (
    <React.Fragment>
      <Layout>
        <Seo title="About Jersey Met" description="Jersey Met Office provides regular weather forecasts for the Channel Islands including shipping and aviation forecasts and weather warnings" />
        <div className="forecastAutoMargin">
          <Grid item xs={12} sm={12} md={8} lg={8} className="menuTitle" style={{paddingLeft:0}}>
            <h1 >About Jersey Met</h1>                  
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={8} lg={8}>
            <div className="Content">
                    {error && (
                      <div>
                        <p style={{ color: "#bf0d0d", marginTop: 0 }}>
                          Sorry, the About Jersey Met information is not
                          available at the moment. Please check back later.
                        </p>
                        <div style={{ textAlign: "center" }}>
                          <Button
                            className="resendButton"
                            onClick={() =>
                              setUrl(process.env.MET_ABOUTJERSEYMET)
                            }
                          >
                            Try again
                          </Button>
                        </div>
                      </div>
                    )}
                  </div>
              {loading ? (
                <Loading />
              ) : (
                <React.Fragment>
                 
                  <React.Fragment>
                    <div className="Content">
                      {aboutJerseyMetData.map((result, index) => (
                        <React.Fragment key={index}>
                          <p  style={{ marginTop: "0" }}>{result.mainBlock}</p>
                          <h2>{result.hoursOpenning}</h2>
                          <p>{result.openningInfo}</p>
                        </React.Fragment>
                      ))}
                      <p>
                        {!error && <Link className="hover-link" to={"/forecasttimes"}>Forecast times</Link>}
                      </p>
                      {!error && <h2>Services provided by Jersey Met</h2>}
                      <ul>
                        {servicesProvidedData.map((result, index) => (
                          <li key={index}>{result.servicesprovided}</li>
                        ))}
                        {!error && 
                          <React.Fragment>
                          <li>
                          weather forecasts on Twitter{" "}
                          <a
                            className="hover-link"
                            target="_blank"
                            rel="noreferrer"
                            href="https://twitter.com/Jersey_Met"
                          >
                            @Jersey_Met
                          </a>
                        </li>
                        <li>
                          weather warnings on Twitter{" "}
                          <a
                            className="hover-link"
                            target="_blank"
                            rel="noreferrer"
                            href="https://twitter.com/Jersey_MetCI"
                          >
                            @Jersey_MetCI
                          </a>
                        </li>
                        </React.Fragment>
                        }
                      </ul>
                    </div>
                  </React.Fragment>
                </React.Fragment>
              )}
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <PremiumServices />
            </Grid>
          </Grid>
        </div>
      </Layout>
    </React.Fragment>
  )
}
export default AboutJerseyMet
